const dbRequest = require('../../../../../js-network/db-request')
const multitable = require('../../../../../components/multitable/multitable')
const inventorySnack = require('./item-snack')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const scrim        = require('../../../../../components/scrim/scrim')

let itemHtmlFc = null
let itemChatsFc = null

export function initChatsFc(chats) {
  itemChatsFc = chats
}

export function getChatsFc() {
  return itemChatsFc
}

export function initDataFc(htmlFc) {
  itemHtmlFc = htmlFc
}

export function getDataFc() {
  return itemHtmlFc
}

// agregar el item_id el item_unit_id como atributo al fullcont
// tambien para colocar la descripcion del articulo con su unidad en su input correspondiente
export function addDataDetail(detail, htmlFc) {
  let input_itemDescription = htmlFc.fullcontHTML.querySelector("#inventory_form_item_detail input");
  input_itemDescription.value = detail.item_name.trim() + ' - ' + detail.item_unit_name.trim();

  htmlFc.fullcontHTML.setAttribute("data-item_id", detail.dbid);
  htmlFc.fullcontHTML.setAttribute("data-item_unit_id", detail.item_unit_id);

}

//funcion para cargar los datos del input y el mt purchase vs lost de la entidad inventory
// se mostraran los purchase que el item tenga dispnibilidad
export function getItemInformation(detail, htmlFc) {

  load(detail, htmlFc)

}

const load = (detail, htmlFc) => {


  return loadDB(detail,htmlFc)
    .then((result) => {



      //the entity was deleted
      if (result.multiTables[0] === undefined) {
        inventorySnack.start({ act: 'show', id: 'noPurchase', });
        return;
      }/**/

      let input_itemId   = htmlFc.fullcontHTML.querySelector('#inventory_form_item_id input');
      input_itemId.value = result.data[0].item_id
      
      let input_itemUnitId   = htmlFc.fullcontHTML.querySelector('#inventory_form_item_unit_id input');
      input_itemUnitId.value = result.data[0].item_unit_id

      htmlFc.formCopy.forEach(element => {
        if (element.name == "item_id") {
              element.value = input_itemId.value;
        }
        if (element.name == "item_unit_id") {
              element.value = input_itemUnitId.value;
        }
      });

      multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: result.multiTables })

      multitable.start({ act: 'generator_insert', entityMT: htmlFc.entityMT })


    }).catch((error) => {

      throw error;
      //console.log('Error Getting Invoice', error)

    })
}/**/

async function loadDB(detail,htmlFc) {

  detail.inf = { item_id: htmlFc.fullcontHTML.getAttribute("data-item_id"), item_unit_id: htmlFc.fullcontHTML.getAttribute("data-item_unit_id") }

  const result = await dbRequest.start(detail, 'server/php/sql/getPurchaseByItem.php') //do the insert

  if (result.status != "ok") { throw (result) }

  return result
}


//verificar que la cantidad digitada sea un valor valido
export function processQtyItemLost(detail) {
  let line = detail.ev.target.closest('.line');

  verifyQtyItemLost(line);
}

// verificar si en la linea enviada el input lost qty tiene un valor  menor o igual al disponible de ese item
export function verifyQtyItemLost(line) {

  let input_lost_qty = line.querySelector('.lost_qty input');
  let available      = parseFloat(line.querySelector('.available input').value);

  let lostQty_value  = (input_lost_qty.value == "" || parseFloat(input_lost_qty.value) == NaN || parseFloat(input_lost_qty.value) == 0) ? 0 :
    parseFloat(input_lost_qty.value);


  if (lostQty_value <= available ) {
    textfieldHandler.errorClean(input_lost_qty.closest(".textfield"));
  } else {
    inventorySnack.start({ act: 'show', id: 'insufficientQuantity', });
    textfieldHandler.error(input_lost_qty.closest(".textfield"));
    return false;
  }

  return true;
}

// para validar el funtcont antes de enviarlo a guardar
export function validated(detail, htmlFc) {

  let allLost = htmlFc.fullcontHTML.querySelectorAll("#inventory_form_purchase_vs_lost  .line");

  if (allLost.length < 1) {
    inventorySnack.start({ act: 'show', id: 'noPurchase', });
    return false;
  }

  let  allInputLostQtyEmpty = true;
  for (let i = 0; i < allLost.length; i++) {
    let line = allLost[i];
    let input_lost_qty = line.querySelector('.lost_qty input');
    let lostQty_value = (input_lost_qty.value == "" || parseFloat(input_lost_qty.value) == NaN || parseFloat(input_lost_qty.value) == 0) ? 0 :
                          parseFloat(input_lost_qty.value);
    
    if (lostQty_value != 0) {
      allInputLostQtyEmpty = false;
    }

  }

  // si todos los input estan en 0, mandar una alerta, no se puede guardar sin datos
  if (allInputLostQtyEmpty) {
    for (let i = 0; i < allLost.length; i++) {
      textfieldHandler.error(allLost[i].querySelector('.lost_qty'));
    }
    inventorySnack.start({ act: 'show', id: 'allInputEmpty', });
    return false;
  }

  // validar que el mt los valores digitados en lost sean correctos es decir no sean mayor a lo disponible
  for (let i = 0; i < allLost.length; i++) {
    let line  = allLost[i];
    
    if (!verifyQtyItemLost(line)) {
      return false;
    }
  }
  return true;

  
}

export function printReport(detail, htmlFc) {
  if (detail.dbid) {
    generateReport(detail.dbid, detail.entity, detail.reportName, detail.item_unit_id);
    return
  }

  const cont = htmlFc.fullcontHTML;
  const id = cont.getAttribute('data-dbid');
  generateReport(id, detail.entity, detail.reportName, detail.item_unit_id);
  return

}

function generateReport(dbid, entity, reportName, item_unit_id) {
  scrim.showLoading()
  const formData = new FormData();
  formData.append('id', dbid);
  formData.append('type', 'print');
  formData.append('entity', entity);
  formData.append('reportName', reportName);
  formData.append('item_unit_id', item_unit_id);

  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/report/report-pdf.php`, options)
    .then((response) => {
      clearTimeout(timeout);
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          scrim.hideLoading()
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        scrim.hideLoading()
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })

    .catch(error => {
      scrim.hideLoading()
      throw error;
    });
}